import React, {FC, useEffect, useState} from 'react';
import s from './OnboardingPage.module.css';
import ProgressBar from "./widgets/progress-bar/ProgressBar";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentTemplate } from "../../store/selectors/templatesSelectors";
import { AppDispatch } from '../../store/store'
import {CreateProjectPayload, UpdateProjectPayload} from "../../shared/types/projectTypes";
import {createProject, generateScript, updateProject} from "../../store/slices/projectSlice";
import {selectCurrentProject, selectIsLoadingProject} from "../../store/selectors/projectSelectors";
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/img/Logo.png'
import shape1 from '../../assets/img/shape1.svg'
import shape2 from '../../assets/img/shape2.svg'
import shape3 from '../../assets/img/shape3.svg'
import shape4 from '../../assets/img/shape4.svg'
import shape5 from '../../assets/img/shape5.svg'
import shape6 from '../../assets/img/shape6.svg'
import shape7 from '../../assets/img/shape7.svg'
import shape8 from '../../assets/img/shape8.svg'
import shape9 from '../../assets/img/shape9.svg'
import LoadingGeneration from "../../shared/ui/loading-generation/LoadingGeneration";
import ModalUpdates from "./widgets/modal-updates/ModalUpdates";
import ActionButtons from "./widgets/action-buttons/ActionButtons";
import ContentDisplay from "./widgets/content-display/ContentDisplay";
import StepContent from "./widgets/step-content/StepContent";


export interface StepData {
    text: string;
    isActive: boolean;
    tag: string;
    color?: string;
    icon?: string;
}

export interface ContentElement {
    header: string;
    text: string;
    element: JSX.Element;
}
export interface InputField {
    value: string;
    placeholder: string;
}

const OnboardingPage: FC = () => {
    const totalSteps: number = 5;
    const isLoadingProject=useSelector(selectIsLoadingProject)
    const currentTemplate = useSelector(selectCurrentTemplate);

    const navigate = useNavigate()
    const dispatch = useDispatch<AppDispatch>();

    const [step, setStep] = useState<number>(0);
    const [isLoading, setIsLoading] = useState(false);
    const [goalValue, setGoalValue] = useState<string>("");

    const [inputsIndustry, setInputs] =  useState<InputField[]>([
        { value: '', placeholder: 'Industry 1' },
        { value: '', placeholder: 'Industry 2' },
        { value: '', placeholder: 'Industry 3' },
    ]);

    const [firstStepData, setFirstStepData] = useState<StepData[]>([
        { text: 'My personal media',tag:'personal', isActive: false,color: '#FFD900FF' },
        { text: 'My client’s media',tag:'client', isActive: false,color: '#eca4f4' },
        { text: 'Other', tag:'other',isActive: false,color: '#76ea8e' },
    ]);

    const [linkedinToneList, setLinkedinToneList] = useState<StepData[]>([
        { text: 'Friendly', isActive: false, tag: 'entertaining', color: '#FFFF01', icon: shape1 },
        { text: 'Exciting', isActive: false, tag: 'exciting', color: '#FABC1E', icon: shape2 },
        { text: 'Fun', isActive: false, tag: 'fun', color: '#43FEAF', icon: shape3 },
        { text: 'Serious', isActive: false, tag: 'serious', color: '#68C0FF', icon: shape4 },
        { text: 'Witty', isActive: false, tag: 'witty', color: '#ECEC41', icon: shape5 },
        { text: 'Persuasive', isActive: false, tag: 'persuasive', color: '#FF7051', icon: shape6 },
        { text: 'Neutral', isActive: false, tag: 'neutral', color: '#F8C9FC', icon: shape7 },
        { text: 'Emotional', isActive: false, tag: 'emotional', color: '#58A0FE', icon: shape8 },
        { text: 'Inspiring', isActive: false, tag: 'inspiring', color: '#28da9e', icon: shape9 },
        // { text: 'Professional', isActive: false, tag: 'professional', color: '#b46acc', icon: shape1 },
        // { text: 'Sarcastic', isActive: false, tag: 'sarcastic', color: '#fa1717', icon: shape2 },
        // { text: 'Personal', isActive: false, tag: 'personal', color: '#e3c229', icon: shape3 },
        // { text: 'Authoritative', isActive: false, tag: 'authoritative', color: '#20b4bf', icon: shape4 },
        // { text: 'Playful', isActive: false, tag: 'playful', color: '#03bc9b', icon: shape5 },
        // { text: 'Assertive', isActive: false, tag: 'assertive', color: '#ec2891', icon: shape6},
        // { text: 'Optimistic', isActive: false, tag: 'optimistic', color: '#26bf1a', icon: shape7 },
        // { text: 'Informal', isActive: false, tag: 'informal', color: '#bcefa0', icon: shape7 },
        // { text: 'Formal', isActive: false, tag: 'formal', color: '#afef14', icon: shape8 },
    ]);

    useEffect(() => {
        if (step === 0) {
            setFirstStepData(prevData =>
                prevData.map(el => ({ ...el, isActive: false }))
            );
        }
    }, [step]);


    const handleChangeIndustry = (index: number, event: React.ChangeEvent<HTMLInputElement>) => {
        const newInputs = [...inputsIndustry];
        newInputs[index].value = event.target.value;
        setInputs(newInputs);
    };

    const toggleToneSelection = (text: string) => {
        setLinkedinToneList(prevList => {
            const activeCount = prevList.filter(el => el.isActive).length;
            return prevList.map(el => {
                if (el.text === text) {
                    if (el.isActive) return { ...el, isActive: false };
                    return activeCount < 3 ? { ...el, isActive: true } : el;
                }
                return el;
            });
        });
    };
    const handleCardItemSelection = (item: StepData) => {
        if (step === 0 || step === 1) {
            setFirstStepData(prevData =>
                prevData.map(el => ({ ...el, isActive: el.text === item.text }))
            );

            if (step === 1) return;
            setStep(prev => Math.min(totalSteps - 1, prev + 1));
        }
    };

    const handleGenerateScript = async () => {



            try {
                setIsLoading(true)
                const projectId = await handleCreateProject();
                if (!projectId) {
                    throw new Error('Project ID is missing');
                }
                const response = await dispatch(generateScript({ projectId: projectId })).unwrap();
                console.log('Script generated successfully:', response);
                navigate(`/text_editor/${projectId}`);
            } catch (error) {
                console.error('Failed to handle generate script:', error);
            }

    };

    const handleCreateProject= async ()=>{
        if(currentTemplate!=null){
            const activeStep = firstStepData.find((step) => step.isActive)!;
            const industryList = inputsIndustry.map((input) => input.value)
            const activeTones = linkedinToneList
                .filter((tone) => tone.isActive)
                .map((tone) => tone.tag)

            const projectDetails:CreateProjectPayload = {
                name: 'Project Name',
                category:activeStep.tag ,
                industry:industryList,
                content_type: currentTemplate.tag,
                goal: goalValue,
                tone:activeTones,

            };

            const newProject = await dispatch(createProject(projectDetails)).unwrap();
            console.log('NEW PROJECT:', newProject);
            return newProject.id;
        }

    }


    const handleSetStep=()=>{
        setStep(prev => Math.min(totalSteps - 1, prev + 1))
    }

    const isStepCompleted = () => {

        if (step === 0) {
            return firstStepData.some((el) => el.isActive);
        }
        if (step === 1) {
            return inputsIndustry.some((input) => input.value.trim() !== '');
        }
        if (step === 2) {
            return currentTemplate !== null;
        }
        if (step ===3) {
            return goalValue.trim()!=''

        }
        if (step ===4) {
            return linkedinToneList.some((el) => el.isActive);

        }
        return true;
    };


    return (
        <div className={s.container}>

            <div className={s.step_container}>
                <div>
                    <img src={logo} className={s.logo}/>
                    <ProgressBar step={step} totalSteps={totalSteps} setStep={setStep}/>

                    <StepContent step={step}
                                 firstStepData={firstStepData}
                                 linkedinToneList={linkedinToneList}
                                 inputs={inputsIndustry}
                                 currentTemplate={currentTemplate}
                                 goalValue={goalValue}
                                 setGoalValue={setGoalValue}
                                 handleInputChange={handleChangeIndustry}
                                 handleCardItemSelection={handleCardItemSelection}
                                 toggleToneSelection={toggleToneSelection}/>
                </div>
                <ActionButtons
                    step={step}
                    totalSteps={totalSteps}
                    isStepCompleted={isStepCompleted}
                    handleSetStep={handleSetStep}
                    handleGenerateScript={handleGenerateScript}/>
            </div>

            <ContentDisplay step={step}
                            linkedinToneList={linkedinToneList}
                           currentTemplate={currentTemplate}
                          />
            <ModalUpdates/>
            {isLoading && <LoadingGeneration/>}

        </div>
    );
};

export default OnboardingPage;
